import { z } from 'zod';

import { WorkoutPlanId } from '../../BrandedIds';
import { BaseLoanEvent } from '../BaseLoanEvent';

export const CancelWorkoutPlanEvent = BaseLoanEvent.extend({
  type: z.literal('cancelWorkoutPlan'),
  workoutPlanId: WorkoutPlanId,
  comment: z.string().optional(),
});
export type CancelWorkoutPlanEvent = z.infer<typeof CancelWorkoutPlanEvent>;
